import { WidgetsRegistry } from '@ayocore/platform/client/widgets';
import { ProjectWelcomeCards } from '../components/welcome/ProjectWelcomeCards';

/**
 * Весь блок карточек проектов — один виджет на WelcomePage.
 * Вызывается из client/bootstrap.ts.
 */
export function registerMwsWelcomeExtensions(): void {
  WidgetsRegistry.register({
    code: 'mws.projects',
    title: 'Проекты',
    Component: ProjectWelcomeCards,
    // Сохраняем ID прежнего statBlock: личные и legacy-настройки видимости
    // остаются действующими. Разметка и загрузка — в прежнем компоненте.
    welcome: { key: 'mws-projects', order: 10, span: 12 },
  });
}
